import * as types from '../../constants/actions';

const initialState = {
  current: undefined,
  isFetchingClassRooms: false,
  isFetchingParticipants: false,
  isFetchingParticipantsHistory: false,
  hasFetchedAllParticipants: false,
  hasFetchedAllParticipantsHistory: false,
  searchingParticipantQuery: null,
  isActingOnParticipant: false,
  isFetchingContent: false,
  isFetchingImportantPosts: false,
  hasFetchedAllImportantPosts: false,
  isFetchingScheduledPosts: false,
  hasFetchedAllScheduledPosts: false,
  isChangingClassRoom: false,
  isChangingAvatar: false,
  isErrored: false,
  filterTag: '',
  lastEventDate: '',
  isFetchingFilteredPosts: false,
  shouldFetchMoreNotifications: false,
  onlineUsers: [],
  hasAddParticipantError: false,
  isAddingParticipantToSpace: false,
};

const changeClassRoomReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isChangingClassRoom: true,
        current: action.payload.id,
        onlineUsers: [],
      };
    case 'success': {
      const {
        payload: { id, tagId },
      } = action;
      return {
        ...state,
        current: id,
        isChangingClassRoom: false,
        hasFetchedAllParticipants: false,
        hasFetchedAllParticipantsHistory: false,
        filterTag: tagId || '',
      };
    }
    case 'error':
      return {
        ...state,
        isChangingClassRoom: false,
        isErrored: true,
      };
    default:
      return state;
  }
};

const fetchClassRoomsReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingClassRooms: true };
    case 'success':
      return {
        ...state,
        isFetchingClassRooms: false,
        isErrored: false,
      };

    case 'error':
      return {
        ...state,
        isFetchingClassRooms: false,
        isErrored: true,
      };

    default:
      return state;
  }
};

const fetchClassRoomParticipantsReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingParticipants: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        isFetchingParticipants: false,
        hasFetchedAllParticipants: action.participants.length === 0,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isFetchingParticipants: false,
      };

    default:
      return state;
  }
};

const fetchClassRoomParticipantsHistoryReducer = (
  state = initialState,
  action
) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingParticipantsHistory: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        lastEventDate: action.lastEventDate,
        isFetchingParticipantsHistory: false,
        hasFetchedAllParticipantsHistory: action.participantsHistoryCount === 0,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isFetchingParticipantsHistory: false,
      };

    default:
      return state;
  }
};

const addParticipantsToSpaceReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isAddingParticipantToSpace: true };
    case 'success': {
      return {
        ...state,
        hasAddParticipantError: false,
        isAddingParticipantToSpace: false,
      };
    }
    case 'error':
      return {
        ...state,
        hasAddParticipantError: true,
        isAddingParticipantToSpace: false,
      };

    default:
      return state;
  }
};

const searchClassRoomParticipantsReducer = (state = initialState, action) => ({
  ...state,
  searchingParticipantQuery: action.query,
});

const classRoomActingOnParticipantReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isActingOnParticipant: true };
    case 'success': {
      return {
        ...state,
        isActingOnParticipant: false,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isActingOnParticipant: false,
      };

    default:
      return state;
  }
};

const fetchClassRoomContentReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingContent: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        isFetchingContent: false,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isFetchingContent: false,
      };

    default:
      return state;
  }
};

const fetchImportantPostsReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingImportantPosts: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        isFetchingImportantPosts: false,
        hasFetchedAllImportantPosts: action.importantPosts.length === 0,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isFetchingImportantPosts: false,
      };

    default:
      return state;
  }
};

const fetchScheduledPostsReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingScheduledPosts: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        isFetchingScheduledPosts: false,
        hasFetchedAllScheduledPosts: action.scheduledPosts.length === 0,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isFetchingScheduledPosts: false,
      };

    default:
      return state;
  }
};

const newPostInClassRoomReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state };
    case 'success': {
      return {
        ...state,
        isErrored: false,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
      };

    default:
      return state;
  }
};

const changeClassroomAvatarReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isChangingAvatar: true };
    case 'success': {
      return {
        ...state,
        isErrored: false,
        isChangingAvatar: false,
      };
    }
    case 'error':
      return {
        ...state,
        isErrored: true,
        isChangingAvatar: false,
      };

    default:
      return state;
  }
};

const filterTagReducer = (state = initialState, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isFetchingFilteredPosts: true,
      };
    case 'added':
      return {
        ...state,
        filterTag: action.tagId,
        isFetchingFilteredPosts: false,
      };
    case 'cleared':
      return {
        ...state,
        filterTag: '',
        isFetchingFilteredPosts: false,
      };
    default:
      return state;
  }
};

const classRoomReducer = (state = initialState, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case types.CLASSROOM_CHANGE:
      return changeClassRoomReducer(state, action);
    case types.CLASSROOM_FETCH_JOINED:
      return fetchClassRoomsReducer(state, action);
    case types.CLASSROOM_FETCH_PARTICIPANTS:
      return fetchClassRoomParticipantsReducer(state, action);
    case types.CLASSROOM_ADD_PARTICIPANTS:
      return addParticipantsToSpaceReducer(state, action);
    case types.CLASSROOM_FETCH_PARTICIPANTS_HISTORY:
      return fetchClassRoomParticipantsHistoryReducer(state, action);
    case types.CLASSROOM_SEARCH_PARTICIPANTS:
      return searchClassRoomParticipantsReducer(state, action);
    case types.CLASSROOM_PROMOTE_PARTICIPANT:
      return classRoomActingOnParticipantReducer(state, action);
    case types.CLASSROOM_UNPROMOTE_PARTICIPANT:
      return classRoomActingOnParticipantReducer(state, action);
    case types.CLASSROOM_REMOVE_PARTICIPANT:
      return classRoomActingOnParticipantReducer(state, action);
    case types.CLASSROOM_FETCH_CONTENT:
      return fetchClassRoomContentReducer(state, action);
    case types.CLASSROOM_CREATE_POST:
      return newPostInClassRoomReducer(state, action);
    case types.FETCH_IMPORTANT_POSTS:
      return fetchImportantPostsReducer(state, action);
    case types.FETCH_SCHEDULED_POSTS:
      return fetchScheduledPostsReducer(state, action);
    case types.CLASSROOM_CHANGE_AVATAR:
      return changeClassroomAvatarReducer(state, action);
    case types.USER_LOGOUT:
      return { ...initialState };
    case types.CLASSROOM_UPDATE_ONLINE_USERS:
      return { ...state, onlineUsers: action.onlineUsers };
    case types.FEED_FILTER_TAG:
      return filterTagReducer(state, action);
    default:
      return state;
  }
};

export default classRoomReducer;
